import { observer } from "mobx-react";
import { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

import { InvisibleSmartCaptcha } from '@yandex/smart-captcha';

import FormLayout from "./FormLayout/FormLayout";
import FormStep1 from "./FormLayout/FormStep1/FormStep1";
import FormStep2 from "./FormLayout/FormStep2/FormStep2";
import FormStep3 from "./FormLayout/FormStep3/FormStep3";
import FormStep4 from "./FormLayout/FormStep4/FormStep4";
import FormStep5 from "./FormLayout/FormStep5/FormStep5";

import paymentFormStore from "./PaymentFormStore";

import {
//SMART_CAPTCHA_KEY,
  SMART_CAPTCHA_TEST,
} from '../../smart-captcha.js';

import "./PaymentForm.scss";

const SMART_CAPTCHA_KEY = '';

const PaymentForm = observer(() => {

  const [captchaKey, setCaptchaKey] = useState(0);
  const [captchaToken, setCaptchaToken] = useState('');
  const [captchaVisible, setCaptchaVisible] = useState(false);

  const navigate = useNavigate();
  const fieldRefs = {
    companyName: useRef(null),
    inn: useRef(null),
    bankAccount: useRef(null),
    bik: useRef(null),
    businessAddress: useRef(null),
    postalAddress: useRef(null),
    accountingNumber: useRef(null),
  };

  const stepComponents = {
    1: FormStep1,
    2: FormStep2,
    3: FormStep3,
    4: FormStep4,
  };

  const handleBackClick = () => {
    if (paymentFormStore.currentStep === 1 || paymentFormStore.currentStep === 5) {
      navigate("/");
    } else {
      paymentFormStore.handleBack();
    }
  };

  const scrollToError = (errorRef) => {
    if (errorRef.current) {
      const headerHeight = 80;
      const rect = errorRef.current.getBoundingClientRect();
      const offsetTop = rect.top + window.scrollY - headerHeight;
      window.scrollTo({ top: offsetTop, behavior: "smooth" });
    }
  };

  const handleNextClick = () => {
    if (paymentFormStore.currentStep === 2) {
      if (!paymentFormStore.validateFormStep2()) {
        const errorRefs = [
          paymentFormStore.companyNameError ? fieldRefs.companyName : null,
          paymentFormStore.innError ? fieldRefs.inn : null,
          paymentFormStore.bankAccountError ? fieldRefs.bankAccount : null,
          paymentFormStore.bikError ? fieldRefs.bik : null,
          paymentFormStore.businessAddressError ? fieldRefs.businessAddress : null,
          paymentFormStore.postalAddressError ? fieldRefs.postalAddress : null,
          paymentFormStore.accountingNumberError ? fieldRefs.accountingNumber : null,
        ];
        const firstErrorRef = errorRefs.find((ref) => ref !== null);
        if (firstErrorRef) {
          scrollToError(firstErrorRef);
        }
        return;
      }
    }

    if (paymentFormStore.currentStep < 4) {
      paymentFormStore.handleNext();
      return;
    }

    if (SMART_CAPTCHA_KEY)
      return setCaptchaVisible(true);
    onCaptchaSuccess(captchaToken);
  };

  const onCaptchaSuccess = async (captchaToken) => {
    setCaptchaVisible(false);
    setCaptchaToken(captchaToken);

    try {
      paymentFormStore.handleNext(captchaToken);
    } finally {
      setCaptchaKey(captchaKey + 1);
    }
  };

  if (paymentFormStore.currentStep === 5) {
    return <FormStep5 onClick={handleBackClick} />;
  }

  const StepComponent = stepComponents[paymentFormStore.currentStep];

  return (
    <div className="payment-form">
      <Helmet>
        <title>Оплата для юридических лиц — Boostclick</title>
        <meta name="description" content="Оплата Boostclick для юридических лиц." />
        <meta name="robots" content="noindex" />
        <link rel="canonical" href={window.location.origin + window.location.pathname} />
      </Helmet>

      <FormLayout
        currentStep={paymentFormStore.currentStep}
        onBack={handleBackClick}
        onNext={handleNextClick}
        isNextDisabled={paymentFormStore.isNextButtonDisabled}
      >
        {StepComponent && <StepComponent refs={fieldRefs} />}
      </FormLayout>

      {SMART_CAPTCHA_KEY && <InvisibleSmartCaptcha
        key={captchaKey}
        sitekey={SMART_CAPTCHA_KEY}
        test={SMART_CAPTCHA_TEST}
        visible={captchaVisible}
        hideShield={true}
        onSuccess={onCaptchaSuccess}
        onTokenExpired={() => setCaptchaToken('')}
        onNetworkError={() => setCaptchaVisible(false)}
        onChallengeHidden={() => setCaptchaVisible(false)}
      />}

    </div>
  );
});

export default PaymentForm;
